import React from "react";
import ReactTooltip from "react-tooltip";
import withStyles from "@material-ui/core/styles/withStyles";
import "react-toastify/dist/ReactToastify.css";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { Button } from "@material-ui/core";
import { useStyles } from "./styles";
import { RE_UPLOAD } from "../../constants/index";

function ReUploadButton({
  classes: { borderRadius, capitalize, marginLeft },
  documentTypeId,
  item,
  modalKey,
  text,
  uploadClickHandler,
}) {
  return item.documents &&
    item.documents[documentTypeId] &&
    item?.documents[documentTypeId].status === "0" ? (
    <>
      <Button
        variant="contained"
        color="primary"
        size={"small"}
        className={`${borderRadius} ${marginLeft} ${capitalize}`}
        onClick={() => uploadClickHandler(item?.id, modalKey)}
        data-tip={`${RE_UPLOAD} "${item?.documents[
          documentTypeId
        ].title.toLowerCase()}" as the "${item?.documents[
          documentTypeId
        ].status_reason.toLowerCase()}"<br /> So it has been marked as "invalid" by the garantie claim review team.`}
      >
        <CloudUploadIcon style={{ margin: "3px 6px" }} />
        {text}
      </Button>
      <ReactTooltip html={true} />
    </>
  ) : (
    ""
  );
}

export default withStyles(useStyles, { withTheme: true })(ReUploadButton);
